import { FC } from 'react';
import {
	CalendarToday,
	FormatColorFillOutlined,
	SensorDoorOutlined,
	SpeedOutlined,
	LocalGasStation,
	TimeToLeaveOutlined,
	PodcastsOutlined,
	SearchOutlined,
	PaidOutlined,
	SettingsOutlined,
	AttachMoney,
} from '@mui/icons-material';
import { CarDetail } from '../../utils';
import { IconInfo } from '../icon-info';

export interface CarInfoProps {
	variant: 'small' | 'large';
	category: CarDetail;
	value: string;
}

const CarInfoIcons = {
	[CarDetail.Color]: <FormatColorFillOutlined fontSize='inherit' />,
	[CarDetail.DistanceTraveled]: <SpeedOutlined fontSize='inherit' />,
	[CarDetail.Doors]: <SensorDoorOutlined fontSize='inherit' />,
	[CarDetail.Engine]: <SettingsOutlined fontSize='inherit' />,
	[CarDetail.FipeCode]: <SearchOutlined fontSize='inherit' />,
	[CarDetail.FipeValue]: <PaidOutlined fontSize='inherit' />,
	[CarDetail.Fuel]: <LocalGasStation fontSize='inherit' />,
	[CarDetail.Plate]: <TimeToLeaveOutlined fontSize='inherit' />,
	[CarDetail.Transmission]: <PodcastsOutlined fontSize='inherit' />,
	[CarDetail.Year]: <CalendarToday fontSize='inherit' />,
	[CarDetail.ValorInicial]: <AttachMoney fontSize='inherit' />,
	[CarDetail.ValorCompreAgora]: <AttachMoney fontSize='inherit' />,
};

const CarInfo: FC<CarInfoProps> = ({ variant = 'small', value, category }) => {
	return (
		<IconInfo
			icon={CarInfoIcons[category as keyof typeof CarInfoIcons]}
			title={category}
			value={value}
			variant={variant}
		/>
	);
};

export default CarInfo;
